export default __webpack_public_path__ + "static/media/banner1.cfa6ba23.png";